import { DatadogIconUrl } from "@p0security/integrations-datadog-shared";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { DatadogAiAccesses } from "./accesses.ts";
import { DatadogAiComponents } from "./components.ts";

const DatadogAiFilters = {
  organization: { keys: ["name"] },
  // Rule filter values compile to regular expressions, so rules can scope by
  // product ("logs_.*"), by verb (".*_read"), or exactly ("logs_read_data").
  policy: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type DatadogAiFilters = typeof DatadogAiFilters;

export const DatadogAiRegistration = Registration({
  accesses: DatadogAiAccesses,
  category: "resource",
  components: DatadogAiComponents,
  docs: {
    install: "agentic-gateway/mcp-server/datadog",
    request: "agentic-gateway/requesting-access",
  },
  filters: DatadogAiFilters,
  itemKind: "Organization",
  label: "Datadog",
  logoUrl: DatadogIconUrl,
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "credential" }],
});

registerIntegration("datadog-ai", DatadogAiRegistration);
